import { addPageAction } from "@src/helpers/monitoring";
import { asosGlobalNamespace } from "@template/constants";

export const emitContentTargetingEvent = data => {
  if (window[asosGlobalNamespace].contentTargeting) {
    window[asosGlobalNamespace].contentTargeting.emit(data);
  }
};

export const emitErrorToNewRelic = data => {
  addPageAction("globalBannerApiError", data);
};
